import React, { useEffect } from 'react';
import useSessionstorage from '@rooks/use-sessionstorage';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import checkMarkIcon from '../../static/icons/checkmark.png';

export const FinishWithoutScanTemperature = (props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [siteOptions] = useSessionstorage('siteOptions');
  const [employeeId] = useSessionstorage('employeeId');
  const [redirectType] = useSessionstorage('redirectType');
  const [isTerminal] = useSessionstorage('isTerminal');
  const [confirmationPageMessage] = useSessionstorage('confirmationPageMessage');

  useEffect(() => {
    props.hideLoader();
  }, [props]);

  const redirectToTerminalMainPage = () => {
    if (isTerminal.isTerminal) {
      setTimeout(() => history.push(`/?siteId=${siteOptions.siteId}&source=terminal&language=${siteOptions.lng}`), 5000);
    } else if (redirectType.redirectType === 'employee') {
      setTimeout(() => history.push(`/employee/${employeeId.employeeId}?siteId=${siteOptions.siteId}`), 5000);
    } else if (redirectType.redirectType !== 'employee') {
      setTimeout(() => history.push(`/?siteId=${siteOptions.siteId}&language=${siteOptions.lng}`), 5000);
    }
  };

  redirectToTerminalMainPage();

  return (
    <div className="flex items-stretch justify-center h-screen bg-blue-gradient shadow-md">
      <div className="successSubmit">
        <img src={checkMarkIcon} alt="Success" />
        <div className="text-lg font-extrabold text-center text-white successText">{t(confirmationPageMessage || 'Signed-in!')}</div>
      </div>
    </div>
  );
};
